import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://crhvhtosowiirohdfmtd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_dQxRPo4OB3IYvPHI6kVkxw_5Nf21Lbp";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage,
  },
});
